import { Injectable } from "@angular/core";
import { Concessao } from "@tivic-team/manager-ts/dist/mob/entities/concessao/concessao.entity";
import { ConcessaoColetivoUrbanoController } from "app/controllers/mob/concessao-coletivo-urbano.controller";
import { ConcessaoColetivoUrbanoDTO, ConcessaoColetivoUrbanoDTOList } from "app/model/dtos/mob/concessao-coletivo-urbano.dto";
import { LoaderService } from "../loader.service";
import { ConcessaoColetivoUrbanoSearch } from "./concessao-coletivo-urbano.search";

@Injectable()
export class ConcessaoColetivoUrbanoService {

    constructor(
        private _concessaoColetivoUrbanoController: ConcessaoColetivoUrbanoController,
        private _loaderService: LoaderService
    ) { }
    
    get(cdConcessionario: number): Promise<ConcessaoColetivoUrbanoDTO> {
        this._loaderService.show();
        return this._concessaoColetivoUrbanoController.get(cdConcessionario).finally(() => this._loaderService.hide());
    }

    async find(search?: ConcessaoColetivoUrbanoSearch): Promise<ConcessaoColetivoUrbanoDTO[]> {
        this._loaderService.show();
        return await this._concessaoColetivoUrbanoController.find(search && search.getFilters() || null).finally(() => this._loaderService.hide());
    }

    async findPermissoes(search?: ConcessaoColetivoUrbanoSearch): Promise<ConcessaoColetivoUrbanoDTOList> {
        this._loaderService.show();
        return await this._concessaoColetivoUrbanoController.findPermissoes(search && search.getFilters() || null).finally(() => this._loaderService.hide());
    }
    
    getConcessao(id: number): Promise<ConcessaoColetivoUrbanoDTO> {
        this._loaderService.show();
        return this._concessaoColetivoUrbanoController.getConcessao(id).finally(() => this._loaderService.hide());
    }

    async getPermissionarios(search?: ConcessaoColetivoUrbanoSearch): Promise<ConcessaoColetivoUrbanoDTO[]> {
        this._loaderService.show();
        return await this._concessaoColetivoUrbanoController.getPermissionarios(search && search.getFilters() || null).finally(() => this._loaderService.hide());
    }

    save(entity: ConcessaoColetivoUrbanoDTO): Promise<ConcessaoColetivoUrbanoDTO> {
        if (!entity.cdConcessao)
            return this.create(entity);
        return this.update(entity);
    }

    create(entity: ConcessaoColetivoUrbanoDTO): Promise<ConcessaoColetivoUrbanoDTO> {
        this._loaderService.show();
        return this._concessaoColetivoUrbanoController.create(entity).finally(() => this._loaderService.hide());
    }

    update(entity: ConcessaoColetivoUrbanoDTO): Promise<ConcessaoColetivoUrbanoDTO> {
        this._loaderService.show();
        return this._concessaoColetivoUrbanoController.update(entity).finally(() => this._loaderService.hide());
    }

    ativar(entity: ConcessaoColetivoUrbanoDTO): Promise<ConcessaoColetivoUrbanoDTO>{
        this._loaderService.show();
        return this._concessaoColetivoUrbanoController.ativar(entity).finally(() => this._loaderService.hide());
    }

    desativar(entity: ConcessaoColetivoUrbanoDTO): Promise<ConcessaoColetivoUrbanoDTO>{
        this._loaderService.show();
        return this._concessaoColetivoUrbanoController.desativar(entity).finally(() => this._loaderService.hide());
    }
    
    getConcessaoByConcessionario(cdConcessionario: number): Promise<Concessao> {
        this._loaderService.show();
        return this._concessaoColetivoUrbanoController.getConcessaoByConcessionario(cdConcessionario).finally(() => this._loaderService.hide());
    }

}